import { GoodgameSignal } from "./GoodgameSignal";

/**
 *    BooleanSignal
 *
 *     @author Alexander
 */

export class BooleanSignal extends GoodgameSignal {
    constructor() {
        super();
    }

    public signal(value: boolean): void {
        super.dispatch(value);
    }
}
